<template>
  <div class="">
    <div class="page-contain">
      <div class="page-contain-tab">
        <div class="content-box">
          <common-crud ref="crud"
            :addNewOrEditData="addNewOrEditData"
            :searchData="searchData"
            :crudApi="crudApi"
            :tableData.sync="messagesData"
            :showEditFormTitle="false"
            :beforeSave="beforeSave"
            :afterSave="handleHospitalLevelChange"
            :afterDelete="handleHospitalLevelChange"
            :selectedDataArray.sync="selectedData"
            :customListResult="true"
          >
            <template slot="customResult">
              <div class="message-box" v-for="(data,index) in messagesData" :key="index">
                <div class="message-box-title">
                  【{{data.titile}}】 {{data.sendTime}}
                </div>
                <div class="message-box-content">
                  <div class="message-box-content-info">{{(data.msgContent?data.msgContent:'&nbsp;') | removeHtmlTag}}</div>
                  <div class="message-box-content-operator">
                    <el-button v-show="data.meetingId" type="text" @click="handleViewClick(data)">
                        查看
                    </el-button>
                  </div>
                </div>
              </div>
            </template>
            <template slot="customTitle">医院层级</template>
          </common-crud>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import listApi from '@/api/messages/list';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      messagesData :[],
      searchData: {
      },
      addNewOrEditData: {
      },
      crudApi: listApi,
      selectedData: [],
    }
  },
  computed: {
    ...mapGetters(['baseDataRecords','basedataGetName','basedataGetNameByRowIdField'])
  },
  methods: {
    ...mapActions(['reloadBaseDataByType']),
    formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData(row, column, cellValue, index) {
      return this.basedataGetNameByRowIdField(column.property, row);
    },
    indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch() {
      this.$refs['crud'].handleSearch(1);      
    },
    handleAddNewClick() {
      this.$refs['crud'].handleAddNew();
    },
    handleEditClick(item) {      
      this.$refs['crud'].handleEdit(item);
    },
    beforeSave(saveData) {
    },
    handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('医院层级管理.xlsx');
    },   
    handleHospitalLevelChange() {
      this.reloadBaseDataByType('HospitalLevel');           
    },
    handleViewClick(data) {
      if(data.readFlag == '0'){
        listApi.readMessageByAnntId({anntIds:[data.anntId]});
      }

      if(data.myMeeting == '1') {
        this.$router.push({
          name: 'meetingplan-application-view',
          params: {'id':data.meetingId}
        }); 
      }
      else {
        this.$router.push({
          name: 'meetingplan-task-view',
          params: {'id':data.meetingId}
        }); 
      }
    }
  },  
  mounted() {    
    this.handleSearch();  
  }
};
</script>

<style lang="less" scoped>
  .message-box {
    width: 800px;
    background: #f8f8f8;
    border-radius: 4px;   
    margin-left: 200px;
    min-height: 90px;
    
    &-title {
      font-size: @subSubFontSize;
      font-weight: bold;
      color: @subSubFontColor;
      height: 20px;
      line-height: 20px;
      padding: 24px 0 0 24px;
    }

    &-content {
        margin-top: 25px;
        padding-bottom: 22px;

        &-info {
        font-size: @contentFontSize;
        font-weight: @contentFontWeight;
        color: @contentFontColor;
        line-height: 20px;
        margin-left: 24px;
        width: 700px;
      }

      &-operator {
        float: right;
        margin: -26px 19px 0 0;
      }
    }
  }

  .message-box + .message-box {
    margin-top: 24px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?c93c3220